import React, { useState } from 'react';
import { 
    Typography, 
    Dialog, 
    DialogTitle, 
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Box,
    Tooltip
} from '@material-ui/core';
import { TrendingUp, Close } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import MetricHistoryChart from './MetricHistoryChart';

const useStyles = makeStyles(theme => ({
    clickableMetric: {
        cursor: 'pointer',
        position: 'relative',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: theme.shadows[4],
            '& $trendIcon': {
                opacity: 1
            }
        }
    },
    trendIcon: {
        position: 'absolute',
        top: 8,
        right: 8,
        opacity: 0,
        transition: 'opacity 0.2s ease-in-out',
        color: theme.palette.primary.main
    },
    dialogContent: {
        minWidth: 800,
        minHeight: 350,
        padding: '8px 16px', // Reduced padding from default
        paddingTop: '4px'    // Minimal top padding
    },
    dialogTitle: {
        padding: '8px 16px 0 16px', // Reduced padding for title
        minHeight: 'auto'
    },
    closeButton: {
        position: 'absolute',
        right: 8,
        top: 8,
        color: '#999'
    }
}));

const ClickableMetricCard = ({ 
    clusterId,
    metricType,
    title,
    value,
    unit,
    children,
    className,
    preSelectedNode,
    ...props 
}) => {
    const classes = useStyles();
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleClick = () => {
        setDialogOpen(true);
    };

    const handleClose = () => {
        setDialogOpen(false);
    };

    return (
        <>
            <Tooltip title={`Click to view ${title} history`} arrow>
                <div 
                    className={`${className} ${classes.clickableMetric}`}
                    onClick={handleClick}
                    {...props}
                >
                    {children}
                    <TrendingUp className={classes.trendIcon} fontSize="small" />
                </div>
            </Tooltip>

            <Dialog
                open={dialogOpen}
                onClose={handleClose}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    style: { position: 'relative' }
                }}
            >
                <DialogTitle className={classes.dialogTitle}>
                    <Typography variant="h6">{title} History</Typography>
                    <IconButton 
                        onClick={handleClose} 
                        size="small"
                        className={classes.closeButton}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                
                <DialogContent className={classes.dialogContent}>
                    <MetricHistoryChart
                        clusterId={clusterId}
                        metricType={metricType}
                        title={title}
                        unit={unit}
                        preSelectedNode={preSelectedNode}
                        hideTitle={true}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ClickableMetricCard;
